export default __webpack_public_path__ + "static/media/WB_Arcade2.f35cbb8e.gif";